import React, {useEffect,useState} from 'react';
import {FormControl , TextField, Grid ,Tooltip,IconButton, Box, Card, CardContent , Typography,CardActions,Button } from '@mui/material/';
import ErrorIcon from '@mui/icons-material/Error';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import FmdGoodIcon from '@mui/icons-material/FmdGood';
import axios from 'axios';

import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';

import FmdBadIcon from '@mui/icons-material/FmdBad';

import Autorize from '../../components/ui/autorize';
import FormLabel from '@mui/material/FormLabel';
import AddressEdit from '../../components/clubs/address_edit';
import Cookies from 'js-cookie'
//https://react-data-table-component.netlify.app/?path=/docs/examples-filtering--filtering
function Address({clubid,secteur,ruleWrite}) {

    const [officerlist, setOfficerlist] = useState("");
    const [errorAxios, setErrorAxios] = useState("false");
    const [autorize, setAutorize] = useState("false");
    const [state, setState] = useState({
       
        modalOpen: false,
        editmode: "",
        addressList: "",
        AffAddress: 1,
        address_edit:"",

    });

    const [addressList, setAddressList] = useState("");
       
   
   /*
    const MyAxios = axios.create({
        headers: { 'Access-Control-Allow-Origin':  process.env.REACT_APP_API},       
        withCredentials: true,
        xsrfCookieName: 'token',
        xsrfHeaderName: 'X-XSRF-TOKEN',
    })*/
const MyAxios = axios.create({    
    headers: { Authorization: "Bearer "+ Cookies.get('token'),
            }      
})

    useEffect(() => {

        if(autorize)
          refreshLoadData()

    },[clubid,autorize]);


    function refreshLoadData()
    {
     
        if(clubid !== "")
        {              
              
            MyAxios.get(process.env.REACT_APP_API + '/clubs/secteur/'+ secteur +'/getAddress/'+ clubid)
            .then((res) => {  

                setAddressList(res.data);  
                setErrorAxios(false);
            })
            .catch((error) => {
                console.log(error);
                setErrorAxios(true);
            });       
        }  
    }

       
    function handleChange(event) {
         const value = event.target.value;
         setState({
           ...state,
           [event.target.id]: value,
         });
    }


    
    function NewAddress () { 
        console.log("Create new Address :");              
        setState({ ...state, modalOpen: true, address_edit: 'new' });
      
    };

    
    function EditAddress (MyValue) { 
        console.log("Set Address To Edit:" + MyValue);
        
      
        setState({ ...state, modalOpen: true, address_edit: MyValue });
        //setState({ ...state, address_edit: false, }); 
        //openModal();

    };
    function closeModal(){       
        refreshLoadData();
        setState({ ...state, modalOpen: false, });
    }

    function getCardIcon(value){       
       
        if (value !== "subpremise" && value !== "premise" && value !== "street_address")
            return  <Tooltip title={<h2 style={{ color: "lightblue" }}>Adresse est invalide, veuillez la modifier</h2>}  style={{ fontSize: '32px' }} placement="right">
                        <IconButton>
                            <FmdBadIcon style={{ color: 'red', fontSize: '32px' }} /> 
                        </IconButton> 
                    </Tooltip>;
        else
            return <Tooltip title={<h2 style={{ color: "lightblue" }}>Adresse valide</h2>}  style={{ fontSize: '32px' }} placement="right">
                        <IconButton>
                            <FmdGoodIcon style={{ color: 'lightblue', fontSize: '32px' }} /> 
                        </IconButton> 
                    </Tooltip>;
    }

    



/*
    function openModal (){
        setState({ ...state, modalOpen: true, });
    }*/

    
    
    function AddressCard(value)
    {
       // console.log(value.Active +" ===  " + state.AffAddress + "=>" + (parseInt(value.Active) ===   parseInt(state.AffAddress)) )
          
            return (
                <Grid item xs={3}>
                    <Card sx={{ maxWidth: 345 , margin:'10px' }} key={"AddCard" + value.addressId}   >                        
                        <CardContent >
                       
                           <Typography gutterBottom variant="h7" component="div">
                           <h4> Type d'adresse: {value.Address_To}   {getCardIcon(value.Address5)} </h4>                            
                           </Typography>
                           <Typography variant="body2" color="text.secondary"> 
                           Pays:{value.Country  }  <br /> 
                           Province:{value.State  }  <br />                                                   
                           Ville:{value.City  }  <br />
                           Adresse: {value.Address1  }<br />                                                   
                           Code postal:{value.Zip  }   <br />


                           Note: {value.Note  }   <br />  

                           </Typography>
                       </CardContent>
                       <CardActions>                    
                            {getButtonEdit(value)}                     
                       </CardActions>
                    </Card>
                </Grid>
            );


    }


      
    function getButtonEdit(value)
    {
       if(ruleWrite === true)
           return(  <Button variant="containedThird" name={value.addressId} onClick={(e) => EditAddress(e.target.name)}>Modifier</Button>     );
    }

    
    const callbackAutoriser = (index) => { // the callback. Use a better name      
        setAutorize(index);     
      };

      function getButtonAddSave()
      {
         if(ruleWrite === true)
             return(  <Button onClick={NewAddress} variant="containedFifth">Ajouter une nouvelle adresse</Button>  );
      }




    return (
        <div>
            <Autorize axiosError={errorAxios} callBackAutoriser={callbackAutoriser}/>

                <Grid container direction="row" spacing={2}>
                    <Grid item xs={1}> 
                        <Typography variant="h6" gutterBottom>Adresse</Typography>
                    </Grid>
                    <Grid item xs={3}> 
                           {getButtonAddSave()}         
                    </Grid> 
                </Grid>

                <Grid container direction="row" spacing={1}>
              

                 <Box  sx={{display: 'flex', flexDirection: 'row' }} >
                    <Grid container direction="row" spacing={2}>   
                        
                        

                            {Object.entries(addressList).map(([key, value]) => (
                            
                                 AddressCard(value)    
                            
                             )                                                    
                            )}
                       
                   </Grid >
           </Box>

        </Grid>



           <Dialog  key="DialogEditAddress"
                        maxWidth="md"
                        open={state.modalOpen}
                >
                        <DialogTitle>Fiche de l'adresse</DialogTitle>
                        <DialogContent dividers>
                        
                       <AddressEdit key="editAdddrtess" idAddress={state.address_edit} clubid={clubid} secteur={secteur}  ruleWrite={ruleWrite} callback={closeModal}/>
                        </DialogContent>

                        <DialogActions>
                        <Button  variant="containedSecondary" onClick={closeModal}>Fermer               
                        </Button>

                        </DialogActions>
                </Dialog>




           </div>
       
    );    
}

export default Address;

/* ****************** permet d'afficher les adddress active et innactive ******
<Grid item xs={12} > 
                             
                                       <FormControl>
                                       <FormLabel id="demo-row-radio-buttons-group-label">Afficher les adresses</FormLabel>
                                       <RadioGroup
                                           row
                                           aria-labelledby="demo-row-radio-buttons-group-label"
                                           name="row-radio-buttons-group"                                        
                                           onChange={handleChange}
                                           value={state.AffAddress}                                        
                                       >
                                           <FormControlLabel  value={1} control={<Radio id="AffAddress" />} label="Actives" />
                                           <FormControlLabel  value={0} control={<Radio id="AffAddress" />} label="Inactives" />                                              
                                       
                                       </RadioGroup>
                                       <Button onClick={NewAddress} variant="containedFifth">AJOUTER NOUVELLE ADRESSE</Button>
                                   </FormControl>
                            
                        </Grid >  
                        
                        */